import React, { useEffect, useState } from "react";
import Navbars from "./Navbar";
import Header from "./Header";
import { Container } from "react-bootstrap";
import DealofWeek from "./Dealsofweek";
import Products from "./Products";
import Hotdeal from "./Hotdeals";
import Footer from "../FOOTER/Footer";
import Shopbybrand from "./Shopbybrand";
import MostPopular from "./MostPopular";
import DealofDay from "./DealofDay";
import ShopTV from "./ShopTV";
import Shoprefrigetor from "./Shoprefrigetor";
import axios from "axios";
import { API_URL } from "../API/config";
import Carousel from "react-bootstrap/Carousel";
import { message } from "antd";

export default function HomeBanner() {
  const [bannerData, setBannerData] = useState<any[]>([]);

  const getHeroBanner = async () => {
    const token = sessionStorage.getItem("token");
  
    try {
      const res = await axios.get(`${API_URL}/api/banner/heroBanners`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const trueData = res.data.banners.filter(
        (val: any) => val.actionButton === true
      );
      setBannerData(trueData);
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    getHeroBanner();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      {bannerData.length > 1 ? (
        <>
          <section style={{ paddingTop: "4rem" }} className="position-relative">
            <Carousel>
              {bannerData.map((val, i) => (
                <Carousel.Item key={i}>
                  {val.link?
                  <a href={val.link} target="_blank">
                    <img
                      className="img-fluid"
                      src={`${API_URL}/images/${
                        val.image || "default-image.jpg"
                      }`}
                      style={{width:"100%"}}
                      loading="lazy"
                      alt={`Banner ${i + 1}`}
                    />
                  </a>:<img
                      className="img-fluid"
                      src={`${API_URL}/images/${
                        val.image || "default-image.jpg"
                      }`}
                      style={{width:"100%"}}
                      loading="lazy"
                      alt={`Banner ${i + 1}`}
                    />}
                </Carousel.Item>
              ))}
            </Carousel>
          </section>
        </>
      ) : bannerData.length === 1 && bannerData[0]?.image ? (
        <section style={{ paddingTop: "4rem" }} className="position-relative">
          {bannerData[0].link?
           <a href={bannerData[0].link} target="_blank">
          <img
            src={`${API_URL}/images/${bannerData[0].image}`}
            className="img-fluid"
            alt="Single Banner"
             loading="lazy"
             style={{width:"100%"}}
          /></a>:<img
          src={`${API_URL}/images/${bannerData[0].image}`}
          className="img-fluid"
          alt="Single Banner"
           loading="lazy"
           style={{width:"100%"}}
        />}
        </section>
      ) : (
        <section style={{ paddingTop: "4rem" }}>
          <p>No banners available.</p>
        </section>
      )}

      <DealofWeek />
      {/* <Products /> */}
      <Hotdeal />
      <Shopbybrand />
      {/* <ShopTV /> */}
      {/* <MostPopular /> */}
      {/* <Shoprefrigetor /> */}
      {/* <DealofDay /> */}
    </>
  );
}
